import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DebugFooterPanelComponent } from "./debug-footer-panel/debug-footer-panel.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { NavComponent } from "./nav/nav.component";
import { NavigationService } from "./nav/navigation.service";
import { NotFoundComponent } from "./not-found/not-found.component";
import { PageTitleComponent } from "./page-title/page-title.component";
import { UserMenuComponent } from "./user-menu/user-menu.component";
import { LocationSelectComponent } from "./dropdown/location-select/location-select.component";
import { LocationOrGroupSelectComponent } from "./dropdown/location-or-group-select/location-or-group-select.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserGroupSelectComponent } from "./dropdown/user-group-select/user-group-select.component";
import { RegionSelectComponent } from "./dropdown/region-select/region-select.component";
import { LocaleSelectComponent } from "./dropdown/locale-select/locale-select.component";
import { CountrySelectComponent } from "./dropdown/country-select/country-select.component";
import { BankSelectComponent } from "./dropdown/bank-select/bank-select.component";
import { LocationIconComponent } from "./location-icon/location-icon.component";
import { CurrencySelectComponent } from "./dropdown/currency-select/currency-select.component";
import { TableComponent } from "./table/table.component";
import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { DirectionSelectComponent } from "./dropdown/direction-select/direction-select.component";
import { CarrierSelectComponent } from "./dropdown/carrier-select/carrier-select.component";
import { SharedModule } from "../shared/shared.module";
import { QuoteListRowComponent } from "./table/quote-list-row/quote-list-row.component";
import { ClientSelectComponent } from "./dropdown/client-select/client-select.component";
import { WeightUnitSelectComponent } from "./dropdown/weight-unit-select/weight-unit-select.component";

import { WysiwygComponent } from "./wysiwyg/wysiwyg.component";
import { UploadComponent } from "./upload/upload.component";
import { ImportReportComponent } from "./import-report/import-report.component";

import { EmailEditorComponent } from "./email-editor/email-editor.component";
import { EmailEditorRepository } from "./email-editor/email-editor.repository";
import { PriceBoxComponent } from "./table/price-box/price-box.component";
import { SurchargeTypeSelectComponent } from "./dropdown/surcharge-type-select/surcharge-type-select.component";
import { LoadTypeSelectComponent } from "./dropdown/load-type-select/load-type-select.component";
import { TransportTypeSelectComponent } from "./dropdown/transport-type-select/transport-type-select.component";
import { UnitTypeSelectComponent } from "./dropdown/unit-type-select/unit-type-select.component";
import { NgxPermissionsModule } from "ngx-permissions";
import { CustomsClearanceStatusSelectComponent } from "./dropdown/customs-clearance-status-select/customs-clearance-status-select.component";
import { UserProgressComponent } from "./user-progress/user-progress.component";
import { RateSelectComponent } from "./dropdown/rate-select/rate-select.component";
import { LocationKindSelectComponent } from "./dropdown/location-kind-select/location-kind-select.component";

import { PercentBoxComponent } from "./table/percent-box/percent-box.component";
import { ListboxModule } from "primeng/listbox";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { QuoteDirectionSelectComponent } from "./dropdown/quote-direction-select/quote-direction-select.component";
import { MarginSelectComponent } from "./dropdown/margin-select/margin-select.component";
import { ManualQuoteTypeSelectComponent } from "./dropdown/manual-quote-type-select/manual-quote-type-select.component";
import { NotificationHighlightComponent } from "./notification-highlight/notification-highlight.component";
import { NotificationRepository } from "../notification/notification.repository";
import { NotificationDropdownComponent } from "./notification-dropdown/notification-dropdown.component";
import { CountryMultiselectComponent } from "./dropdown/country-multiselect/country-multiselect.component";
import { MarginTypeSelectComponent } from "./dropdown/margin-type-select/margin-type-select.component";
import { CarrierMultiselectComponent } from "./dropdown/carrier-multiselect/carrier-multiselect.component";
import { RateMultiselectComponent } from "./dropdown/rate-multiselect/rate-multiselect.component";
import { MenubarModule } from "primeng/menubar";
import { MenuModule } from "primeng/menu";
import { SelectModule } from "primeng/select";
import { MultiSelectModule } from "primeng/multiselect";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ContextMenuModule } from "primeng/contextmenu";
import { TooltipModule } from "primeng/tooltip";
import { PopoverModule } from "primeng/popover";
import { PopoverArrowDirective } from "app/ui/popover/popover-arrow.directive";

import { SurchargeTypeAutocompleteComponent } from "./dropdown/surcharge-type-autocomplete/surcharge-type-autocomplete.component";
import { AvailableOnlineSelectComponent } from "./dropdown/available-online-select/available-online-select.component";
import { LocationMultiselectComponent } from "./dropdown/location-multiselect/location-multiselect.component";
import { LocationGroupSelectComponent } from "./dropdown/location-group-select/location-group-select.component";

import { DatePickerModule } from "./date-picker/date-picker.module";
import { DatePickerModule as PrimeNgDatePickerModule } from "primeng/datepicker";
import { UserMultiselectComponent } from "./dropdown/user-multiselect/user-multiselect.component";
import { RateStatusMultiselectComponent } from "./dropdown/rate-status-multiselect/rate-status-multiselect.component";
import { ClipboardRowComponent } from "./table/clipboard-row/clipboard-row.component";
import { MaerskLocationSelectComponent } from "./dropdown/maersk-location-select/maersk-location-select.component";
import { QuillModule } from "ngx-quill";
import QuillTableBetter from "quill-table-better";
import QuillResize from "quill-resize-module";
import PlaceholderModule from "./wysiwyg/placeholder-module/placeholder-module";
import { RouterLink } from "@angular/router";
import { CompanyMultiselectComponent } from "./dropdown/company-multiselect/company-multiselect.component";
import { CompanySelectComponent } from "./dropdown/company-select/company-select.component";
import { LanguageSelectComponent } from "./dropdown/language-select/language-select.component";
import { OrganizationSelectComponent } from "./dropdown/organization-select/organization-select.component";
import { TeamSelectComponent } from "./dropdown/team-select/team-select.component";
import { TeamMultiselectComponent } from "./dropdown/team-multiselect/team-multiselect.component";
import { SearchBoxComponent } from "./search-box/search-box.component";

@NgModule({
  imports: [
    NgxPermissionsModule.forChild(),
    RouterLink,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MenubarModule,
    MenuModule,
    SelectModule,
    MultiSelectModule,
    AutoCompleteModule,
    TableModule,
    InputTextModule,
    ListboxModule,
    DatePickerModule,
    SharedModule,
    ContextMenuModule,
    TooltipModule,
    PrimeNgDatePickerModule,
    ProgressSpinnerModule,
    PopoverModule,
    PopoverArrowDirective,
    QuillModule.forRoot({
      customModules: [
        {
          implementation: PlaceholderModule,
          path: "modules/placeholder",
        },
        {
          implementation: QuillTableBetter,
          path: "modules/table-better",
        },
        {
          implementation: QuillResize,
          path: "modules/resize",
        },
      ],
      customOptions: [
        {
          import: "attributors/style/size",
          whitelist: ["10px", "16px", "22px", "36px", "48px", "72px", "144px"],
        },
      ],
    }),
    HeaderComponent,
    NavComponent,
    PageTitleComponent,
    AvailableOnlineSelectComponent,
    NotFoundComponent,
    FooterComponent,
    DebugFooterPanelComponent,
    ManualQuoteTypeSelectComponent,
    RateStatusMultiselectComponent,
    NotificationHighlightComponent,
    NotificationDropdownComponent,
    UserMenuComponent,
    LocationSelectComponent,
    MaerskLocationSelectComponent,
    LocationGroupSelectComponent,
    LocationOrGroupSelectComponent,
    LocationMultiselectComponent,
    LocationKindSelectComponent,
    UserMultiselectComponent,
    MarginSelectComponent,
    LoadTypeSelectComponent,
    QuoteDirectionSelectComponent,
    RateSelectComponent,
    RateMultiselectComponent,
    TransportTypeSelectComponent,
    UnitTypeSelectComponent,
    UserGroupSelectComponent,
    MarginTypeSelectComponent,
    RegionSelectComponent,
    LocaleSelectComponent,
    LanguageSelectComponent,
    CountrySelectComponent,
    CountryMultiselectComponent,
    CurrencySelectComponent,
    CustomsClearanceStatusSelectComponent,
    TableComponent,
    BankSelectComponent,
    DirectionSelectComponent,
    CarrierSelectComponent,
    CarrierMultiselectComponent,
    QuoteListRowComponent,
    CompanyMultiselectComponent,
    CompanySelectComponent,
    OrganizationSelectComponent,
    ClipboardRowComponent,
    LocationIconComponent,
    ClientSelectComponent,
    WeightUnitSelectComponent,
    WysiwygComponent,
    UploadComponent,
    ImportReportComponent,
    EmailEditorComponent,
    PriceBoxComponent,
    PercentBoxComponent,
    TeamSelectComponent,
    TeamMultiselectComponent,
    SurchargeTypeSelectComponent,
    SurchargeTypeAutocompleteComponent,
    UserProgressComponent,
    SearchBoxComponent,
  ],
  providers: [NavigationService, NotificationRepository, EmailEditorRepository],
  exports: [
    CommonModule,
    FormsModule,
    MenubarModule,
    MenuModule,
    SelectModule,
    MultiSelectModule,
    PopoverArrowDirective,
    AvailableOnlineSelectComponent,
    ManualQuoteTypeSelectComponent,
    RateStatusMultiselectComponent,
    QuoteDirectionSelectComponent,
    HeaderComponent,
    NavComponent,
    PageTitleComponent,
    NotFoundComponent,
    RateSelectComponent,
    RateMultiselectComponent,
    UnitTypeSelectComponent,
    MarginSelectComponent,
    FooterComponent,
    NotificationHighlightComponent,
    NotificationDropdownComponent,
    UserMenuComponent,
    LocationSelectComponent,
    MaerskLocationSelectComponent,
    LocationGroupSelectComponent,
    LocationOrGroupSelectComponent,
    LocationMultiselectComponent,
    LocationKindSelectComponent,
    CustomsClearanceStatusSelectComponent,
    UserMultiselectComponent,
    UserGroupSelectComponent,
    RegionSelectComponent,
    LocaleSelectComponent,
    LanguageSelectComponent,
    CountrySelectComponent,
    CountryMultiselectComponent,
    CurrencySelectComponent,
    TableComponent,
    BankSelectComponent,
    DirectionSelectComponent,
    CarrierSelectComponent,
    CarrierMultiselectComponent,
    CompanyMultiselectComponent,
    CompanySelectComponent,
    OrganizationSelectComponent,
    LocationIconComponent,
    ClientSelectComponent,
    WeightUnitSelectComponent,
    WysiwygComponent,
    UploadComponent,
    ImportReportComponent,
    TeamSelectComponent,
    TeamMultiselectComponent,
    EmailEditorComponent,
    SurchargeTypeSelectComponent,
    SurchargeTypeAutocompleteComponent,
    UserProgressComponent,
    SearchBoxComponent,
  ],
})
export class UiModule {}
